import { Directive, ElementRef, HostListener, inject, input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Directive({
   selector: '[cwoAriaForm]',
   standalone: true
})
export class AriaFormDirective {
   cwoAriaForm = input<FormGroup>();

   private host = inject(ElementRef);

   constructor() { }

   @HostListener('submit')
   onSubmit() {
      if (!this.cwoAriaForm()?.valid) {
         this.focusInFirstInvalidField();
         return;
      }
   }

   private focusInFirstInvalidField() {
      const invalidControl = this.host.nativeElement.querySelector(
         '.ng-invalid[formcontrolname], .ng-invalid[formControlName]'
      ) as HTMLElement | null;

      if (!invalidControl) return;

      // In case we use a custom input comopnent
      const focusableChild = invalidControl.querySelector<HTMLElement>('input, textarea, select, [tabindex]');

      const elementToFocus = focusableChild ?? invalidControl;

      if (!elementToFocus.hasAttribute('tabindex')) {
         elementToFocus.setAttribute('tabindex', '0');
      }

      elementToFocus.focus({ preventScroll: false });
   }
}
